import * as Yup from 'yup'

const qrLinkUpdateSchema = Yup.object().shape({
  overrideUrl: Yup.string().url('validation-url-invalid').nullable(),
})

export { qrLinkUpdateSchema }
